<template>
    <b-container class="headerPushDown">
        <p class="text-muted breadCrumbs text-uppercase" v-if="$store.getters.getBasket.items && $store.getters.getBasket.items.length > 0">
                <span class="font-weight-bold text-dark">1.Warenkorb</span> | 2.Details | 3.Überprüfen
        </p>
        <b-container v-if="$store.getters.getBasket.items && $store.getters.getBasket.items.length > 0" class="">
            <b-row v-if="!showMobileTable" class=" mr-3 mr-lg-0">
                <b-col cols="12" class="text-dark">
                    <b-table responsive
                        :bordered="false"
                        :borderless="true"
                        :outlined="false" 
                        :hover="false"
                        :items="this.$store.getters.getBasket.items" 
                        :fields="tableHeaderFields"> 
                        <!-- A virtual index column -->
                       <!--  <template slot="index" slot-scope="data">
                            {{ data.index + 1 }}
                        </template> -->

                        <template slot="image" slot-scope="data">                       
                        <b-img v-if="data.item.image != undefined" :src="$store.getters.getWebServerBaseUrl + data.item.image"
                        width="100px" />
                        </template>

                        <template slot="title" slot-scope="data">                       
                            <div class="font-weight-bold" v-html="data.item.title"></div> 
                            <div class="text-gray" v-html="data.item.description"></div> 
                        </template>

                        <template slot="price" slot-scope="data">                      
                        <div class="text-no-wrap p-0">
                            € {{ data.item.price.toFixed(2) }}
                        </div>  
                        </template>
                        
                        <template slot="count" slot-scope="data">
                            <div class="product-amount-selection flex-center" v-if="data.item.maximumCount > 1">
                                <button class="button-minus ml-1 pl-1 pr-2 pt-n1 pb-2" v-on:click="substractItemCount(data.item)">-</button>
                                    <div class="text-center text-bold">
                                        {{data.item.count }}
                                    </div>
                                <button class="button-plus mr-0 pl-1 pr-2 pb-2" v-on:click="addItemCount(data.item)">+</button> 
                            </div>
                            <div v-else class="text-center">
                                {{data.item.count}}
                            </div> 
                        </template>

                        <template slot="total" slot-scope="data"> 
                            <div class="text-no-wrap p-0">
                                € {{ data.item.total.toFixed(2) }}  
                            </div>                      
                                                
                        </template>

                        <template slot="remove" slot-scope="data">                       
                            <div class="button-close" style="cursor: pointer;" v-on:click="removeItemCount(data.item)"><i class="fa fa-times" aria-hidden="true"></i></div> 
                        </template>
                        
                    </b-table>
                </b-col>    
                        
            </b-row>
           
            <b-row v-if="showMobileTable">
                <b-col cols="12">
                    <!-- TABLEHEADING -->
                    <b-row class=" border-bottom"> 
                        <b-col cols="6" class="text-uppercase text-dark font-weight-bold text-center">Produkt</b-col> 
                        <b-col cols="6" class="text-uppercase text-dark font-weight-bold text-center">Preis</b-col>
                    </b-row>
                    <b-row v-for="(item,index) in $store.getters.getBasket.items" :key="index" class="mb-2 pb-2 mt-2">
                        <b-col class="p-0 pr-1"  cols="6">
                            <div class="text-gray font-weight-bold" v-html="item.title"></div> 
                            <div class="ml-1" v-html="item.description"></div>
                        </b-col>
                        <b-col cols="6" class="p-0 pl-1">                          
                            <div class="button-close float-right mr-4" style="cursor: pointer;" v-on:click="removeItemCount(item)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </div> 

                            <div class="product-amount-selection mt-0 p-0 ml-0" v-if="item.maximumCount > 1">
                                  Anzahl:
                                <button class="button-minus ml-1 pl-1 pr-2 pt-n1 pb-2" v-on:click="substractItemCount(item)">-</button>
                                    <div class="text-center ">
                                        {{item.count }}
                                    </div>
                                <button class="button-plus mr-0 pl-1 pr-2 pb-2" v-on:click="addItemCount(item)">+</button> 
                            </div>
                            <div v-else class="">
                                 Anzahl:&nbsp;&nbsp;
                                <span class="">{{item.count}}</span>
                            </div> 
                                                        
                            <div>Preis:&nbsp;&nbsp;&nbsp;&nbsp; € <span class="">{{ item.price.toFixed(2) }}</span></div>

                            <div>Gesamt: € <span class="font-weight-bold">{{ item.total.toFixed(2) }}</span>   </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

           
            <b-row class="border-bottom  mt-md-3 border-top" >
                <b-col cols="12" md="4" lg="3" class="">
                    <div v-b-toggle.collapse1.collapse2 style="cursor: pointer;" class="button-close ">
                        <label class="ml-0 ml-md-3 mt-3">Gutscheine/Rabattcode <i class="fa fa-plus" aria-hidden="true"></i></label>                           
                    </div>                    
                </b-col>
                <b-col cols="12" md="5" lg="7">
                    <b-collapse id="collapse1" class="pt-3">          
                        <b-form-input v-model="redeemCode" size="sm" class="" type="text" placeholder="Gutschein / Rabattcode eingeben" />
                        <div v-if="redeemCodeError" class="text-danger mt-2">{{redeemCodeError}}</div> 
                    </b-collapse>
                </b-col>  
                <b-col cols="12" md="3" lg="2">
                    <b-collapse id="collapse2" class="">    
                        <b-button size="sm" class="float-right" block variant="light" v-on:click="useRedeemCode">EINLÖSEN</b-button>
                    </b-collapse>
                </b-col>          
            </b-row>

            <b-row class="mt-3 mb-1" >
                <b-col cols="2">
                    <label class="ml-0 ml-md-3">Zwischensumme</label>
                </b-col>
                <b-col cols="10" class="text-right">
                    <label class="mr-3">€ {{$store.getters.getBasket.subTotal.toFixed(2)}}</label>
                </b-col>
            </b-row>
            <b-row >
                <b-col cols="2" v-if="$store.getters.getBasket.shipping > 0">
                    <label class="ml-1 ml-md-3">Versandkosten</label>
                </b-col>
                <b-col  cols="10" class="text-right" v-if="$store.getters.getBasket.shipping > 0">
                    <label class="mr-3">€ {{$store.getters.getBasket.shipping.toFixed(2)}}</label>
                </b-col>
            </b-row>

            <b-row  class="border-bottom">
                <b-col  cols="2" v-if="$store.getters.getBasket.discount > 0">
                    <label class="ml-0 ml-md-3  text-danger">Rabatt</label>
                </b-col>
                <b-col  cols="10" class="text-right" v-if="$store.getters.getBasket.discount > 0">
                    <label class="mr-3 text-danger">€ {{$store.getters.getBasket.discount.toFixed(2)}}</label>
                </b-col>
            </b-row>
           
            <b-row class="mt-3">
                <b-col cols="2">
                    <label class="ml-0 ml-md-3 font-weight-bold text-dark">Summe</label>
                </b-col>
                <b-col  cols="10" class="text-right font-weight-bold text-dark">
                    <label class="mr-3">€ {{$store.getters.getBasket.total.toFixed(2)}}</label>
                </b-col>
            </b-row>


            <b-row v-if="$store.getters.getBasket.taxes.length == 0" class="mt-2">
                <div v-if="$store.getters.getBasket.tax == 0">
                <b-col cols="12">
                    <label class="ml-0 ml-md-3">MwSt. für Wertgutscheine wird bei Erbringung der Leistung ausgewiesen</label>
                </b-col>
                </div>
                <div v-if="$store.getters.getBasket.tax != 0">
                <b-col cols="4">
                    <label class="ml-0 ml-md-3">davon&nbsp;MwSt.</label>
                </b-col>
                <b-col  cols="8" class="text-right">
                    <label class="mr-3">€ {{ $store.getters.getBasket.tax.toFixed(2)}}</label>
                </b-col>  
                </div> 
            </b-row>

            <b-row v-if="$store.getters.getBasket.taxes.length > 0" class="p-0 m-0 mt-2 ">
                <b-col cols="12">
                    <b-row v-for="(tax, index) in $store.getters.getBasket.taxes" :key="index">

                        <b-col cols="4" class="p-0">
                            <label class="ml-0 ml-md-3">MwSt. {{tax.percentage}} %</label>
                        </b-col>
                        <b-col  cols="8" class="text-right">
                            <label class="mr-2">€ {{tax.total.toFixed(2)}}</label>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
   
       
            <b-row class="pt-2 border-top"> 
                <b-col sm="4">
                    
                </b-col>
                <b-col sm="8" class="text-right">
                    <b-button @click="openCheckout" class="mt-2 text-uppercase" size="sm" variant="light" style="float: right;">
                        weiter zu Details
                    </b-button>  
                </b-col>
            </b-row>  
           
           <b-row>
               <b-col cols="12">
                   <Shop-Upselling-Panel :upSellingProducts="getUpsellingSorted"></Shop-Upselling-Panel>
               </b-col>
           </b-row>
        
        </b-container>
        <b-container v-else >
            <h4 class="text-center">Warenkorb leer</h4>  
            <b-row>
                <b-col cols="12" md="4" class="text-center">
                                <b-btn variant="light" to="/app/vouchers">Gutscheine</b-btn>
                </b-col>
                <b-col cols="12" md="4" class="text-center">
                    <b-btn variant="light"  to="/app/tickets">Tisch buchen</b-btn >
                </b-col>
                 <b-col cols="12" md="4" class="text-center">
                    <b-btn variant="light"  to="/app/booking">Reservieren</b-btn >
                </b-col>
            </b-row>
        </b-container>
  </b-container>
</template>

<script>
import ShopUpsellingPanel from '@/components/ShopUpsellingPanel.vue'

export default {
    name: 'ShopCartView',
    components: {
       ShopUpsellingPanel
    },
    data() {
        return {
            panelData: [],
            upSellingProducts: undefined,
            redeemCode: '',
            redeemCodeError: undefined,
            tableHeaderFields:{
                itemImage: {
                    key: 'index',
                    label: '',
                    sortable: false,
                },
                image: {
                    key: 'image',
                    label: '', // FIXME: multilanguage!!!
                    sortable: false,
                },
                product: {
                    key: 'title',
                    label: 'PRODUKT', // FIXME: multilanguage!!!
                    sortable: false,
                },
                price: {
                    key: 'price',
                    label: 'PREIS', // FIXME: multilanguage!!!
                    sortable: false,
                    class: 'text-center'
                },
                count: {
                    key: 'count',
                    label: 'ANZAHL', // FIXME: multilanguage!!!
                    sortable: false,
                    class: 'text-center'
                },
                totalPrice: {
                    key: 'total',
                    label: 'GESAMT', // FIXME: multilanguage!!!
                    sortable: false,
                    class: 'text-center'
                },
                remove: {
                    key: '',
                    label: '', // FIXME: multilanguage!!!
                    sortable: false,
                }
            },
            showMobileTable: false,
        };
    },
    computed: {   
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        getVideoPanelData() {
            return {
                title: this.getLanguageItem["ShopUi"]["HeaderMessage"],
                titleClass: this.getLanguageItem["ShopUi"]["HeaderMessageClass"],
                description: this.getLanguageItem["ShopUi"]["HeaderMessageSubText"],
                descriptionClass: this.getLanguageItem["ShopUi"]["HeaderMessageSubTextClass"]
            };
        },
        getCurrentImage(){
           return this.$store.getters.getWebServerBaseUrl ;
        },
        getUpsellingSorted(){
            //this.getUpselling();
            if (!this.upSellingProducts) {
                this.getUpselling();
            
            }else{
            
               // console.log('Sorted: ', this.upSellingProducts, this.uniqBy(this.upSellingProducts, 'id'));
                // show only unique items
                return this.uniqBy(this.upSellingProducts, 'id');
            }
            

            return [];
        },
        getBasketItems(){
            return this.$store.getters.getBasket.items;
        }
    },
    methods:{
        uniqBy(arr,comp) { // returns array with unique items, no dudlicates! for object arrays
            const unique = arr
            .map(e => e[comp])

            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);

            return unique;
        },        
        getUniqueProductsFromBasket(){
            // make new array based on the productId
            let items= [];
            this.getBasketItems.forEach(e=>{                
                items.push(e.productId);
            });
            // trick to make new array:
            return [...new Set(items)] ; // reduce to unique items, skipps any already existing items
        },
        getUpselling(){
           // console.log('get UPselling');
            
           this.getUniqueProductsFromBasket().forEach( p =>{   
             //  console.log('prod:', p);
                           
                this.loadUpSellingFromServer(p);
            });
        },
        async loadUpSellingFromServer(productId) {
        //console.log('P ID:',productId);
        
        let config = {
            header: this.$store.getters.getRestHeader,
            params: {
                productId: productId,
                localeId: this.getSelectedLanguage.ident, /* Language: de, en */
                imageSize: 'medium',
            }
        };
        await this.$http
            .get(this.$store.getters.getRestServerBaseUrl + "/upSelling", config)
            .then(response => {
              this.upSellingProducts = [];
               // console.log("GET Upselling: ", response.status, response.data);
                // upselling comes as array:
                response.data.forEach(e => {          
                    this.upSellingProducts.push(e);
                });                                 
            })
            .catch(err => {
                console.log("GET Upselling FAILED: ", err);
            });
        },
        async postUpdateBasket(params) {      
    
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = undefined; // make sure they are empty           

            //console.log('POST updateBasket:', params, config);

            await this.$http
                .post(this.$store.getters.getRestServerBaseUrl + "/updateBasket", params , config)
                .then(response => {
                //console.log("POST updateBasket response: "  + response.status, response.data); 

                // save to store
                this.$store.dispatch('saveBasket', response.data);
                })
                .catch(err => {
                console.log("POST updateBasket ERROR: ", err);
                });
        },
        async postRemoveFromBasket(params) { // URL Parameter     
    
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = undefined; // make sure they are empty           

            //console.log('POST removeFromBasket:', params, config);

            await this.$http
                .post(this.$store.getters.getRestServerBaseUrl + "/removeFromBasket", params , config)
                .then(response => {
                    //console.log("POST removeFromBasket response: "  + response.status, response.data);         
                    
                    // save response to store
                    this.$store.dispatch('saveBasket', response.data);

                })
                .catch(err => {
                console.log("POST removeFromBasket ERROR: ", err);
                });
        },  
        async postRedeemCode(params) { // URL Parameter     
    
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = undefined; // make sure they are empty           

            //console.log('POST redeem:', params, config);

            await this.$http
                .post(this.$store.getters.getRestServerBaseUrl + "/redeem", params , config)
                .then(response => {
                   // console.log("POST redeem response: "  + response.status, response.data);         
                    this.redeemCode = '';
                    this.redeemCodeError = undefined;
                    // save response to store
                    this.$store.dispatch('saveBasket', response.data);

                })
                .catch(err => {
                    console.log("POST redeem ERROR: ", err);
                    // FIXME validation error to gui
                    this.redeemCodeError = 'Code wurde nicht akzeptiert'; // FIXME: Multilanguage
                });
        }, 
        addItemCount(item){
            // console.log(item);
            if(item.maximumCount > item.count ){
                let params = {
                    id: item.id,
                    count: item.count+1,
                };
                //console.log('Add:', params);

                this.postUpdateBasket(params);

            }else{
                //FIXME: visual Error ?
                console.log('Max count reached:' , item.maximumCount); 
            } 

        },  
        substractItemCount(item){
            // console.log(item);
            if(item.count > 1){
                let params = {
                    id: item.id,
                    count: item.count-1,
                };
                //console.log('Subtract:',params);

                this.postUpdateBasket(params);
            }else{
                //FIXME: visual Error ?
                console.log('Min count reached: 1'); 
            }             
        },
        removeItemCount(item){
            // url parameter
            let params = {orderItemId: item.id};

            this.postRemoveFromBasket(params);
        },
        useRedeemCode(){
            //console.log('Code:', this.redeemCode);

            // Cleanup
            if (this.redeemCode.trim() == '') {
              //  console.log('Code empty?');
                this.redeemCodeError = undefined;
                return;                
            }

            let params = {
                code: this.redeemCode.trim().toUpperCase(),
            };

            this.postRedeemCode(params)
        },
        openCheckout(){
            // check basket
            this.$router.push('/app/checkout');
        },
        handleResize() {
           // this.window.width = window.innerWidth;
           // this.window.height = window.innerHeight;

            //console.log('width', window.innerWidth);
            if(window.innerWidth < 768){
                this.showMobileTable=true;
            }else{
                this.showMobileTable=false;
            }
            
        }
    },
    mounted(){

        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
        });
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>
